<template>
  <div class="main-content-container container-fluid px-4">
    <div class="page-header row no-gutters py-4">
      <div class="col-8 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Generic \ <span class="ActiveURL">Pricing and Availablity</span></span>
        <!-- <h3 class="page-title">upload Syncc data</h3> -->
      </div>
    </div>
    <d-card class="card-small mb-4">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <h6 class="m-0">Upload Syncc data</h6>

        <!-- <router-link :to="{ name: 'user-setup'}">
          <button
            class="btn btn-md btn-primary"
            style="margin-left: 900px;background-color:white;margin-top:-40px;color:black;"
          >Dashboard</button>
        </router-link> -->
      </d-card-header>

      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col>
              <d-form id="pricing">
                <d-form-row>
               

                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">From Country *</label>
                    <div class="col-md-4">
                      <select class="form-control" v-model="UploadSyncc.DataModel.Data.FromCountry">
                    <option style="padding:50px" v-for="Dropdown in UploadSyncc.Masters.CountryMaster" :value="Dropdown" :key="Dropdown.ReferenceNo" >{{ Dropdown.FromCountry }}</option>
                    </select>
                    </div>
                 </d-col>

                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Upload Synccentric file *</label>
                    <div class="col-md-7" v-if="UploadSyncc.DataModel.UIData.UploadedDataCount == 0">   
                     <!-- <ejs-uploader ref="uploadObj" :uploading="importExcel"   id='Noonfileupload' name="UploadFiles"></ejs-uploader> -->
                         <div class="button_group">
                          <a href="javascript:;" class="button_s my_file el-button button_s el-button--primary el-button--small" >
                          
                          <input type="file" id="avatar" @change="importExcel" name="avatar">
                          </a>
                          <d-button type="button" id="submit" title="Please Select the panel" :disabled="(UploadSyncc.DataModel.Data.FromCountry ==null || UploadSyncc.DataModel.Data.SynccentricScrapList ==0 || UploadSyncc.DataModel.UIData.UploadedDataCount > 0 )" class="btn-accent" @click="getQuery" style="margin-right:10px" >upload Data</d-button>
                                <d-button type="button" id="submit" class="btn-accent" @click="ClearFileData">Cancel</d-button>
                          </div>
                    </div>
                     <div class="col-md-7" v-if="UploadSyncc.DataModel.UIData.UploadedDataCount > 0">  
                         <div class="SuccessLabel">
                           <span class="material-icons"> done_all </span> {{ UploadSyncc.DataModel.UIData.LoadedFileName }} file data uploaded Successfully 
                         </div>
                    </div>
                  </d-col>
                 

                 <d-col md="12" class="form-group row" v-if="(UploadSyncc.DataModel.UIData.UploadedDataCount > 0 && UploadSyncc.DataModel.Data.SynccentricScrapList > 0)">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds from file</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{UploadSyncc.DataModel.Data.SynccentricScrapList}}</label>
                    </div>
                 </d-col>

                 <d-col md="12" class="form-group row" v-if="UploadSyncc.DataModel.UIData.UploadedDataCount > 0">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds from table</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{UploadSyncc.DataModel.UIData.UploadedDataCount}}</label>
                    </div>
                 </d-col>

                 <d-col md="12" class="form-group row"  v-if="UploadSyncc.DataModel.UIData.UploadedDataCount > 0">
                    <label class="col-md-3 col-form-label">Panel *</label>
                    <div class="col-md-4">
                      <select class="form-control" @change="panelOnchange()" v-model="UploadSyncc.DataModel.Data.PanelInfo">
                    <option style="padding:50px" v-for="Dropdown in UploadSyncc.Masters.PanelList" :value="Dropdown"
                      :key="Dropdown.ReferenceNo" >{{ Dropdown.Name }}</option>
                    </select>
                    </div>
                 </d-col>

                 <d-col md="12" class="form-group row"  v-if="UploadSyncc.DataModel.UIData.UploadedDataCount > 0">
                    <label class="col-md-3 col-form-label">Country</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{UploadSyncc.DataModel.Data.PanelInfo.Country}}</label>
                    </div>
                 </d-col>

                  <d-col md="12" class="form-group row" v-if="UploadSyncc.DataModel.UIData.TemplateIsAvailable">
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="UploadSyncc.DataModel.UIData.Template"  :name="UploadSyncc.DataModel.UIData.FileName"><span style="marige-top:10px;" > Download Data </span>   </download-excel>
                    </d-button>
                    </div>
                  </d-col>


                  <d-col md="12" class="form-group row"  v-if="UploadSyncc.DataModel.UIData.AvailablityTemplateCount" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="UploadSyncc.DataModel.UIData.AvailablityTemplate"  :name="UploadSyncc.DataModel.UIData.AvailabilityFileName"><span style="marige-top:10px;" > Download UnAvailability Template </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>

                <d-col md="12" class="form-group row"  v-if="UploadSyncc.DataModel.UIData.AvailablityList.length > 0" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="UploadSyncc.DataModel.UIData.AvailablityList"  :name="UploadSyncc.DataModel.UIData.AvailabilityTemplateFileName"><span style="marige-top:10px;" > Download Availability Template </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>
                <d-col md="12" class="form-group row"  v-if="UploadSyncc.DataModel.UIData.minMaxList.length > 0" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="UploadSyncc.DataModel.UIData.minMaxList"  :name="UploadSyncc.DataModel.UIData.MinMaxFileName"><span style="marige-top:10px;" > Download Price min & max Template </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>
                </d-form-row>
                <br />
                <div class style="text-align:center"  v-if="UploadSyncc.DataModel.UIData.UploadedDataCount >0">
                  <d-button type="button" id="submit" title="Please Select the panel" :disabled="(UploadSyncc.DataModel.Data.PanelInfo.Country == null || UploadSyncc.DataModel.Data.FromCountry ==null || UploadSyncc.DataModel.UIData.TemplateIsAvailable)" class="btn-accent" @click="GetList" style="margin-right:10px" >Submit</d-button>
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                </div>
              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
    <div v-if="UploadSyncc.PageLoad" class="load-container load1"><div class="loader">Loading...</div></div>
  </div>
</template>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
import xlsx from "xlsx";
import XLSX from 'xlsx';
export default {
  name: 'UploadSyncc',
   data() {
    return {
      UploadSyncc: {
        PageType: "Master",
        PageLoad: false, 
        DataModel: {
          Data: {
             QueryString:null,
            PanelInfo:{
              Name:null,
              Country:null
            },
            FromCountry:null,
            SynccentricScrapList:[],
            Token:null,
            Curd:null,
            CreatedBy:0
          },
          UIData: {
            mySteps:['Step 1', 'Step 2', 'Step 3'],
            currentStep:0,
            Template:[],
            minMaxList:[],
            AvailablityTemplate:[],
            AvailablityList:[],
            AvailablityTemplateCount:0,
            TemplateIsAvailable :false,
            FileName:"Template",
            LoadedFileName:"",
            AvailabilityFileName:"Template",
            UploadedDataCount:0
          },
        },
        SessionInfo: {
          PageInfo: {
            userId: 0,
          },
        },
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: "",
          },
        ],

        Masters: {
          CountryMaster:[],
          PanelList:[
            {
              Name : "Amazon UAEDirect",
              Country:"UAEDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon India",
              Country:"India",
              Panel:"Amazon"
            },
            {
              Name : "Amazon IndiaDirect",
              Country:"IndiaDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Australia",
              Country:"Australia",
              Panel:"Amazon"
            },
            {
              Name : "Amazon UAE",
              Country:"UAE",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Mexico",
              Country:"Mexico",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Canada",
              Country:"Canada",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Brazil",
              Country:"Brazil",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Singapore",
              Country:"Singapore",
              Panel:"Amazon"
            },
            {
              Name : "Amazon KSA",
              Country:"KSA",
              Panel:"Amazon"
            },
            {
              Name : "Jokoka",
              Country:"UAE",
               Panel:"Jokoka"
            },
            {
              Name : "StoreUS",
              Country:"UAE",
               Panel:"StoreUS"
            },
            {
              Name : "Noon UAE",
              Country:"UAE",
              Panel:"Noon"
            },
            {
              Name : "Noon KSA",
              Country:"KSA",
              Panel:"Noon"
            }
          ]
        },
      },
    };
  },

  mounted(){
      this.UploadSyncc.SessionInfo.PageInfo.userId = sessionStorage.getItem("UserId");
       this.UploadSyncc.DataModel.Data.CreatedBy = sessionStorage.getItem("UserId");
      this.ListAllFromCountry();
  },
  methods: {
ClearFileData(){
     this.UploadSyncc.DataModel.Data.FromCountry = null;
     document.getElementById("pricing").reset();
},

panelOnchange(){
            this.UploadSyncc.DataModel.UIData.Template=[];
            this.UploadSyncc.DataModel.UIData.TemplateIsAvailable = false;
},

ClearUsersetup(){
            this.UploadSyncc.DataModel.UIData.Template = [];
            this.UploadSyncc.DataModel.UIData.TemplateIsAvailable = false;
            this.UploadSyncc.DataModel.UIData.minMaxList = [];
            this.UploadSyncc.DataModel.UIData.AvailablityList = [];
            this.UploadSyncc.DataModel.Data.SynccentricScrapList = 0;
            this.UploadSyncc.DataModel.Data.PanelInfo ={
              Name : null,
              Country:null
        }
        this.UploadSyncc.DataModel.Data.FromCountry =null;
        this.UploadSyncc.DataModel.UIData.UploadedDataCount= 0;
        document.getElementById("pricing").reset();
      },

      ListAllFromCountry(){
        let vm = this;
        vm.UploadSyncc.PageLoad = true;
        var Token = sessionStorage.getItem("Token");
        this.UploadSyncc.DataModel.Data.Token = Token;
        this.UploadSyncc.DataModel.Data.CRUD = "ListAllFromCountry";
        var dataString = JSON.stringify(this.UploadSyncc.DataModel.Data);
        axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
          .then(function (response) {
            if (response.data.ErrorInfo == null) {
              vm.UploadSyncc.PageLoad = false;
              vm.UploadSyncc.Masters.CountryMaster = response.data.Result;
            } else {

            }
          })
          .catch(function (response) {
            console.log(response);
              vm.UploadSyncc.PageLoad = false;
            vm.$swal.fire("Oops", "Something went worng", "error");
          });
      },


getQuery()
{
        let vm = this;
      vm.UploadSyncc.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.UploadSyncc.DataModel.Data.Token = Token;
      this.UploadSyncc.DataModel.Data.CRUD = "AmazonAEMasterUpload";
      var dataString = JSON.stringify(this.UploadSyncc.DataModel.Data);
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.UploadSyncc.PageLoad = false;
            vm.UploadSyncc.DataModel.UIData.UploadedDataCount= response.data.Result;
          } else {

          }
        })
        .catch(function (response) {
          console.log(response);
            vm.UploadSyncc.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

},



      GetList(){
      let vm = this;
      vm.UploadSyncc.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.UploadSyncc.DataModel.Data.Token = Token;
      
      this.UploadSyncc.DataModel.UIData.FileName = this.UploadSyncc.DataModel.Data.PanelInfo.Name + " " + Date.now();
      this.UploadSyncc.DataModel.UIData.AvailabilityFileName = this.UploadSyncc.DataModel.Data.PanelInfo.Name + "UnAvailability" + " " + Date.now();
      this.UploadSyncc.DataModel.UIData.AvailabilityTemplateFileName = this.UploadSyncc.DataModel.Data.PanelInfo.Name + "Availability" + " " + Date.now();
      this.UploadSyncc.DataModel.UIData.MinMaxFileName = this.UploadSyncc.DataModel.Data.PanelInfo.Name + "Min and Max Pricing" + " " + Date.now();
      this.UploadSyncc.DataModel.Data.CreatedBy = this.UploadSyncc.SessionInfo.PageInfo.userId;
      var ListParameter = Utilities.JsonCopy(this.UploadSyncc.DataModel.Data);

      ListParameter.SynccentricScrapList = [];
      var dataString = null;

      if(this.UploadSyncc.DataModel.Data.PanelInfo.Panel == "Noon")
      {
        ListParameter.CRUD = "GetNoonList";
        dataString = JSON.stringify(ListParameter);
        this.NoonTemplate(dataString);
      }
      else if(this.UploadSyncc.DataModel.Data.PanelInfo.Panel == "Amazon")
      {
        ListParameter.CRUD = "GetAmazonList";
        dataString = JSON.stringify(ListParameter);
        this.AmazonTemplate(dataString);
      }
      },


      UploadSynccData(){
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.UploadSyncc.DataModel.Data.Token = Token;
      this.UploadSyncc.DataModel.Data.CRUD = "Create";
      this.UploadSyncc.DataModel.UIData.FileName = this.UploadSyncc.DataModel.Data.PanelInfo.Name + " " + Date.now();
      var dataString = JSON.stringify(this.UploadSyncc.DataModel.Data);
       vm.UploadSyncc.PageLoad = true;
       vm.UploadSyncc.DataModel.UIData.UploadedDataCount = 0;
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.UploadSyncc.PageLoad = false;
            vm.$toaster.success("Save Successfully.");
              console.log(response.data.Result);  
            vm.UploadSyncc.DataModel.UIData.UploadedDataCount = response.data.Result;
 
          } else {
              console.log(response.data.ErrorInfo);
              vm.UploadSyncc.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Mobile No, Date or Amount !","error");
          }
        })
        .catch(function (response) {
          console.log(response);  
          vm.UploadSyncc.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
      },

  // UploadedDataCount

  
      NoonTemplate(dataString){
       let vm = this;
       
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.UploadSyncc.PageLoad = false;
            
            // console.log(response.data.Result);
            var FullList = response.data.Result;
            var exportTemp= Utilities.JsonCopy(FullList.filter(c => c.price !=0));

              exportTemp.map(function(key,value){

                  vm.UploadSyncc.DataModel.UIData.Template.push(Utilities.JsonCopy(key));

              // if(vm.UploadSyncc.DataModel.Data.FromCountry.FromCountry == 'India')
              // {

              //   // 00304BAUXXB07G4CWK1D
              //   if(key.partner_sku.substring(5, 10) == 'BAIXX')
              //   {
              //     vm.UploadSyncc.DataModel.UIData.Template.push(Utilities.JsonCopy(key));
              //   }
              // }
              // else
              // {
              //   if(key.partner_sku.substring(5, 10) == 'BAUXX')
              //   {
              //     vm.UploadSyncc.DataModel.UIData.Template.push(Utilities.JsonCopy(key));
              //   }
              // }
            });

             vm.UploadSyncc.DataModel.UIData.Template.map(function(key,value){

             var AvailabilityTemplate={
            country_code:key.country_code,
            id_partner:key.id_partner,
            partner_sku:key.partner_sku,
            psku_code:key.psku_code,
            x_noon_sku:key.x_noon_sku,
            noon_warehouse_code:'W00015767A',
            x_noon_title:null,
            x_noon_brand:null,
            current_stock_gross:null,
            current_processing_time:null,
            x_stock_status_reason:null,
            stock_gross:2,
            processing_time:"10_days"
          };

        var minMax={
        country_code : 	key.country_code,
        id_partner :	key.id_partner,
        psku_code	:key.psku_code,
        partner_sku	: key.partner_sku,
        current_price_min :	null,
        current_price_max	: null,
        price_min	: Math.ceil(key.price - ((10/100) * key.price)),
        price_max : Math.ceil(Number((10/100) * key.price) + Number(key.price))

        }
  
            vm.UploadSyncc.DataModel.UIData.minMaxList.push(Utilities.JsonCopy(minMax));
            vm.UploadSyncc.DataModel.UIData.AvailablityList.push(Utilities.JsonCopy(AvailabilityTemplate));

          });


            var UnAvailablityTemplate= Utilities.JsonCopy(FullList.filter(c => c.price ==0));  

              UnAvailablityTemplate.map(function(key,value){

             var AvailabilityTemplate={
            country_code:key.country_code,
            id_partner:key.id_partner,
            partner_sku:key.partner_sku,
            psku_code:key.psku_code,
            x_noon_sku:key.x_noon_sku,
            noon_warehouse_code:'W00015767A',
            x_noon_title:null,
            x_noon_brand:null,
            current_stock_gross:null,
            current_processing_time:null,
            x_stock_status_reason:null,
            stock_gross:0,
            processing_time:"10_days"
          };

            vm.UploadSyncc.DataModel.UIData.AvailablityList.push(Utilities.JsonCopy(AvailabilityTemplate));

              });

            if(vm.UploadSyncc.DataModel.UIData.AvailablityTemplate.length > 0)
            vm.UploadSyncc.DataModel.UIData.AvailablityTemplateCount = true;
            

            if(vm.UploadSyncc.DataModel.UIData.Template.length > 0)
            {
              vm.$toaster.success("Successfully Generated.");
              vm.UploadSyncc.DataModel.UIData.TemplateIsAvailable = true;
            }
            else
            {
              vm.$toaster.info("0 Records Founded.");
              vm.UploadSyncc.DataModel.UIData.TemplateIsAvailable = false;
            }


          } else {
              console.log(response.data.ErrorInfo);
                vm.UploadSyncc.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Data !","error");
          }
        })
        .catch(function (response) {
          console.log(response);
            vm.UploadSyncc.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

    },

  
    AmazonTemplate(dataString){
       let vm = this;
        vm.UploadSyncc.DataModel.Data.CRUD = "GetAmazonList";
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.UploadSyncc.PageLoad = false;
            // vm.$toaster.success("Save Successfully.");
            // console.log(response.data.Result);

            response.data.Result.map(function(key,value){

                key.minimum_seller_allowed_price=Math.ceil(key.price - ((10/100) * key.price));	
                key.maximum_seller_allowed_price=Math.ceil(Number((10/100) * key.price) + Number(key.price));

            });



            if(vm.UploadSyncc.DataModel.Data.PanelInfo.Name  == "Amazon India")
              {
                  var BusinessPriceTemplate={
                    sku:null,	
                    price:null,	
                    minimum_seller_allowed_price:null,	
                    maximum_seller_allowed_price:null,	
                    quantity:null,	
                    leadtime_to_ship:null,	
                    fulfillment_channel:null,	
                    merchant_shipping_group_name:null,	
                    business_price:null,	
                    quantity_price_type	:null, 
                    quantity_lower_bound1:null,	
                    quantity_price1:null,	
                    quantity_lower_bound2:null,	
                    quantity_price2:null,	
                    quantity_lower_bound3:null,	
                    quantity_price3:null,	
                    quantity_lower_bound4:null,	
                    quantity_price4:null,	
                    quantity_lower_bound5:null,	
                    quantity_price5:null
                  };

                  response.data.Result.map(function(key,value){

                      key.minimum_seller_allowed_price=Math.ceil(key.price - ((10/100) * key.price));	
                      key.maximum_seller_allowed_price=Math.ceil(Number((10/100) * key.price) + Number(key.price));

                      BusinessPriceTemplate.sku= key.sku;
                      BusinessPriceTemplate.price= key.price;
                      BusinessPriceTemplate.minimum_seller_allowed_price= key.minimum_seller_allowed_price;
                      BusinessPriceTemplate.maximum_seller_allowed_price= key.maximum_seller_allowed_price;
                      BusinessPriceTemplate.quantity= key.quantity;
                      BusinessPriceTemplate.business_price =  key.price;
                      BusinessPriceTemplate.leadtime_to_ship =  key.handling_time;

                      vm.UploadSyncc.DataModel.UIData.Template.push(Utilities.JsonCopy(BusinessPriceTemplate));

                      BusinessPriceTemplate={
                          sku:null,	
                          price:null,	
                          minimum_seller_allowed_price:null,	
                          maximum_seller_allowed_price:null,	
                          quantity:null,	
                          leadtime_to_ship:null,	
                          fulfillment_channel:null,	
                          merchant_shipping_group_name:null,	
                          business_price:null,	
                          quantity_price_type	:null, 
                          quantity_lower_bound1:null,	
                          quantity_price1:null,	
                          quantity_lower_bound2:null,	
                          quantity_price2:null,	
                          quantity_lower_bound3:null,	
                          quantity_price3:null,	
                          quantity_lower_bound4:null,	
                          quantity_price4:null,	
                          quantity_lower_bound5:null,	
                          quantity_price5:null
                  };

                  });
              } 
              else
              {
                  vm.UploadSyncc.DataModel.UIData.Template = response.data.Result;
              }           
            
            console.log(response.data.Result);

            if(vm.UploadSyncc.DataModel.UIData.Template.length > 0)
            {
              vm.$toaster.success("Successfully Generated.");
              vm.UploadSyncc.DataModel.UIData.TemplateIsAvailable = true;
            }
            else
            {
              vm.$toaster.info("0 Records Founded.");
              vm.UploadSyncc.DataModel.UIData.TemplateIsAvailable = false;
            }

          } else {
              console.log(response.data.ErrorInfo);
                vm.UploadSyncc.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Mobile No, Date or Amount !","error");
          }
        })
        .catch(function (response) {
          console.log(response);
            vm.UploadSyncc.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
    },


    getHeader(sheet) {
      const XLSX = xlsx;
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]); // worksheet['!ref'] Is the valid range of the worksheet
      let C;
      /* Get cell value start in the first row */
      const R = range.s.r; //Line / / column C
      let i = 0;
      for (C = range.s.c; C <= range.e.c; ++C) {
        var cell =
          sheet[
            XLSX.utils.encode_cell({ c: C, r: R })
          ]; /* Get the cell value based on the address  find the cell in the first row */
        var hdr = "UNKNOWN" + C; // replace with your desired default
        // XLSX.utils.format_cell Generate cell text value
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        if(hdr.indexOf('UNKNOWN') > -1){
          if(!i) {
            hdr = '__EMPTY';
          }else {
            hdr = '__EMPTY_' + i;
          }
          i++;
        }
        headers.push(hdr);
      }
      return headers;
    },
    /**
     * Import table
     */
     importExcel(e) {

      const files = e.target.files;
      this.UploadSyncc.PageLoad = true;
      this.UploadSyncc.DataModel.UIData.LoadedFileName = files[0].name;
      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.UploadSyncc.PageLoad = false;
        return alert("The upload format is incorrect. Please upload xls or xlsx format");
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          console.log(ev);
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
          const excellist = []; // Clear received data
          // Edit data

          // var loopCount =  ws.length/20000


          this.UploadSyncc.DataModel.Data.SynccentricScrapList = 0 ;
          this.UploadSyncc.DataModel.Data.QueryString = "INSERT INTO `SynccentricScrap` (`ASIN`, `Description`, `buybox_new_landed_price`, `lowest_new_price`, `lowest_new_shipping`, `lowest_new_price_fba`, `lowest_new_shipping_fba`, `CreatedBy`, `IsActive`) VALUES";


          // for (var i = 0; i < loopCount; i++) {

          // }

          console.log(ws.length);

          for (var i = 0; i < ws.length; i++) {


            var ScrabData={
              asin:null,
              description:null,
              buybox_new_landed_price:0,
              lowest_new_price:0,
              lowest_new_price_fba:0,
              lowest_new_shipping:0,
              lowest_new_shipping_fba:0,
              CreatedBy:0
            }


            if(ws[i].asin !=undefined)
            {
                ScrabData.asin = ws[i].asin;
          
            }
            else
            {
              ScrabData.asin = null;
            }

            if(ws[i].buybox_new_landed_price !=undefined )
            {
              if(isNaN(ws[i].buybox_new_landed_price))
                 ScrabData.buybox_new_landed_price = ws[i].buybox_new_landed_price.replaceAll(',', '');
                 else
                 ScrabData.buybox_new_landed_price = ws[i].buybox_new_landed_price;
            }
            else
            {
                ScrabData.buybox_new_landed_price = 0;
            }

            if(ws[i].description !=undefined)
            {
                // ScrabData.description = ws[i].description.replaceAll('\'', '\'\'');
                // ScrabData.description = ScrabData.description.replaceAll('?', '?\\r\\n');
                // ScrabData.description = ScrabData.description.replaceAll('&', '&\\r\\n');
                ScrabData.description ="-";
            }
            else
            {
                ScrabData.description =null;
            }

            if(ws[i].lowest_new_price !=undefined)
            {
              if(isNaN(ws[i].lowest_new_price))
                ScrabData.lowest_new_price = ws[i].lowest_new_price.replaceAll(',', '');
                else
                ScrabData.lowest_new_price = ws[i].lowest_new_price;
            }
            else
            {
              ScrabData.lowest_new_price = 0;
            }

            if(ws[i].lowest_new_price_fba !=undefined)
            {
              if(isNaN(ws[i].lowest_new_price_fba))
                ScrabData.lowest_new_price_fba = ws[i].lowest_new_price_fba.replaceAll(',', '');
                else
                ScrabData.lowest_new_price_fba = ws[i].lowest_new_price_fba;
                
            }
            else
            {
              ScrabData.lowest_new_price_fba = 0;
            }
            if(ws[i].lowest_new_shipping !=undefined)
            {
              if(isNaN(ws[i].lowest_new_shipping))
                ScrabData.lowest_new_shipping = ws[i].lowest_new_shipping.replaceAll(',', '');
                else
                ScrabData.lowest_new_shipping = ws[i].lowest_new_shipping;
                
            }
            else
            {
              ScrabData.lowest_new_shipping = 0;
            }
            if(ws[i].lowest_new_shipping_fba !=undefined )
            {
                if(isNaN(ws[i].lowest_new_shipping_fba))
                  ScrabData.lowest_new_shipping_fba = ws[i].lowest_new_shipping_fba.replaceAll(',', '');
                else
                  ScrabData.lowest_new_shipping_fba = ws[i].lowest_new_shipping_fba;
            }
            else
            {
                ScrabData.lowest_new_shipping_fba = 0;
            }

             ScrabData.CreatedBy = this.UploadSyncc.SessionInfo.PageInfo.userId;


            this.UploadSyncc.DataModel.Data.QueryString = this.UploadSyncc.DataModel.Data.QueryString + "(\'" + ScrabData.asin + "\',\'" +ScrabData.description + "\'," +  ScrabData.buybox_new_landed_price + "," + ScrabData.lowest_new_price + "," + ScrabData.lowest_new_shipping  + "," +   ScrabData.lowest_new_price_fba + "," +ScrabData.lowest_new_shipping_fba + ","+ this.UploadSyncc.SessionInfo.PageInfo.userId+","+ 1 +")";

            if(i < (ws.length - 1))
            {
              this.UploadSyncc.DataModel.Data.QueryString = this.UploadSyncc.DataModel.Data.QueryString+"," 
            }
            this.UploadSyncc.DataModel.Data.SynccentricScrapList +=1;
            
            // this.UploadSyncc.DataModel.Data.SynccentricScrapList.push(ScrabData);
            //  excellist.push(ws[i]);
          }

          
           this.UploadSyncc.DataModel.Data.QueryString = this.UploadSyncc.DataModel.Data.QueryString+";"
          // console.log("Read results", this.UploadSyncc.DataModel.Data.SynccentricScrapList); // At this point, you get an array containing objects that need to be processed
          // Get header2-1

          const a = workbook.Sheets[workbook.SheetNames[0]];
          const headers = this.getHeader(a);
          console.log('headers', this.UploadSyncc.DataModel.Data.SynccentricScrapList);  
          this.UploadSyncc.PageLoad = false;
          console.log(this.UploadSyncc.DataModel.Data.QueryString); 
          // this.UploadSyncc.DataModel.Data.QueryString = JSON.stringify(this.UploadSyncc.DataModel.Data.QueryString); 
          // Get header2-2
        } catch (e) {
          console.log(e); 
            this.UploadSyncc.PageLoad = false;
          return alert("Read failure!");;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
    },

 previewFiles(e) {
          console.log("test");
          var files = e.target.files, f = files[0];
          var reader = new FileReader();
          reader.onload = function(e) {
            var data = new Uint8Array(e.target.result);
            var workbook = XLSX.read(data, {type: 'array'});
            let sheetName = workbook.SheetNames[0]
            /* DO SOMETHING WITH workbook HERE */
            console.log(workbook);
            let worksheet = workbook.Sheets[sheetName];
            console.log(XLSX.utils.sheet_to_json(worksheet));
          };
          reader.readAsArrayBuffer(f);
       }


  }
}
</script>